import styled from 'styled-components';

export const ContainerWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100dvh;
  background-image: url('/assets/images/real-estate-platform-homepage-immersive-experience.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;
